import React from "react";
import * as Sentry from "@sentry/react";
import StrongDemand from "./StrongDemand";
import { Pagination, ResultListResult } from "./search";
import ErrorSearch from "./ErrorSearch";

const SearchResultList = ({
  searchAttributes,
  stats,
  hasCriterias,
  results,
  pagination,
  changeUrl,
}) => (
  <div>
    <Sentry.ErrorBoundary fallback={ErrorSearch}>
      <StrongDemand stats={stats} hasCriterias={hasCriterias} />
      {stats && stats.all_results_count > 0 && (
        <ul className="list-hotels">
          {results.map((result) => (
            <ResultListResult
              key={result.hotel.id}
              result={result}
              searchAttributes={searchAttributes}
            />
          ))}
        </ul>
      )}

      {pagination && pagination.count_pages > 1 && (
        <Pagination changeUrl={changeUrl} pagination={pagination} />
      )}
    </Sentry.ErrorBoundary>
  </div>
);

export default SearchResultList;
